import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {BizSharedModule} from '../../biz-shared.module';
import {LocationListComponent} from './location-list/location-list.component';
import {UserLocationListComponent} from './user-location-list/user-location-list.component';
import {UserLastLocationListComponent} from './user-last-location-list/user-last-location-list.component';
import {DistributorCustomerLocationListComponent} from './distributor-customer-location-list/distributor-customer-location-list.component';
import {DistributorLocationListComponent} from './distributor-location-list/distributor-location-list.component';
import {CustomerLocationListComponent} from './customer-location-list/customer-location-list.component';
import {DealerLocationListComponent} from './dealer-location-list/dealer-location-list.component';
import {AgmOverlays} from 'agm-overlays';
import {MatProgressBarModule, MatTooltipModule} from '@angular/material';
import {TimelineByDateRangeComponent} from './timeline-by-date-range/timeline-by-date-range.component';
import {MonitoringLastLocationsComponent} from './monitoring-last-locations/monitoring-last-locations.component';
import {MonitoringUserTimelineComponent} from './monitoring-user-timeline/monitoring-user-timeline.component';
import {MonitoringUserTimelineByDateRangeComponent} from './monitoring-user-timeline-by-date-range/monitoring-user-timeline-by-date-range.component';
import {AgmCoreModule, LAZY_MAPS_API_CONFIG, LazyMapsAPILoaderConfigLiteral} from '@agm/core';
import {AppConfigService} from '../../services/app-config.service';
import {AllUserTimelineByDateRangeComponent} from './all-user-timeline-by-date-range/all-user-timeline-by-date-range.component';

export function mapConfigFactory(configService: AppConfigService): LazyMapsAPILoaderConfigLiteral {
    return {
        apiKey: configService.mapApiKey
    };
}

@NgModule({
    declarations: [
        LocationListComponent, UserLocationListComponent, UserLastLocationListComponent,
        DistributorCustomerLocationListComponent, DistributorLocationListComponent, CustomerLocationListComponent,
        DealerLocationListComponent, TimelineByDateRangeComponent, MonitoringLastLocationsComponent,
        MonitoringUserTimelineComponent, MonitoringUserTimelineByDateRangeComponent, AllUserTimelineByDateRangeComponent
    ],
    imports: [
        AgmCoreModule.forRoot(),
        RouterModule.forChild([
            {
                path: 'all-user-timeline-by-date-range',
                component: AllUserTimelineByDateRangeComponent
            },
            {
                path: 'list',
                component: LocationListComponent
            },
            {
                path: 'user-last-location-list',
                component: UserLastLocationListComponent
            },
            {
                path: 'distributor-customer-location-list',
                component: DistributorCustomerLocationListComponent
            },
            {
                path: 'distributor-location-list',
                component: DistributorLocationListComponent
            },
            {
                path: 'customer-location-list',
                component: CustomerLocationListComponent
            },
            {
                path: 'dealer-location-list',
                component: DealerLocationListComponent
            },
            {
                path: 'timeline-by-date-range',
                component: TimelineByDateRangeComponent
            },
            {
                path: 'monitoring-last-locations',
                component: MonitoringLastLocationsComponent
            },
            {
                path: 'monitoring-user-timeline',
                component: MonitoringUserTimelineComponent
            },
            {
                path: 'monitoring-user-timeline-date-range',
                component: MonitoringUserTimelineByDateRangeComponent
            },

        ]),
        BizSharedModule,
        AgmOverlays,
        MatTooltipModule,
        MatProgressBarModule
    ],
    exports: [
        AgmCoreModule
    ],
    providers: [
        {
            provide: LAZY_MAPS_API_CONFIG,
            useFactory: mapConfigFactory,
            deps: [AppConfigService]
        }
    ]
})
export class LocationModule {
}
